import React, { Component } from 'react';
import ReactExport from "react-export-excel";
import Moment from 'moment';
import axios from 'axios';
import {API_URL} from '../../../constants';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class TrazabilidadExcel extends Component {

    constructor(props)
    {
        super(props);
    }

    props = {
        dataReport: []
      }

    render() {
        return (
            <ExcelFile filename="TRAZABILIDAD" element={<a href="#" className="btnReporte_Log">REPORTE</a>}>
                <ExcelSheet data={this.props.dataReport} name="TRAZABILIDAD">
                    <ExcelColumn label="ACCIÓN" value="traz_Accion"/>
                    <ExcelColumn label="DETALLE" value="traz_DetalleAccion"/>                    
                    <ExcelColumn label="NAVEGADOR" value="traz_Navegador"/>   
                    <ExcelColumn label="CORREO" value="clie_Correo"/>   
                    <ExcelColumn label="IP" value="traz_IpCreacion"/>   
                    <ExcelColumn label="FECHA DE REGISTRO" value={(col) => Moment(col.traz_FechaCreacion).format('DD/MM/YYYY')}/>                        
                </ExcelSheet>
            </ExcelFile>
        )
    }
}
